































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { POSProduct, POSProductType } from '@pos/interfaces/pos-v2';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import BpcPosContactForm from './pos-contact-form.vue';
import { Contact } from '@contacts/interfaces/contact';

interface ErrorObjectInterface {
  ibanNumber: string;
  bicNumber: string;
}
export type errorsKeys = keyof ErrorObjectInterface;
export type errorObject = Partial<Record<errorsKeys, string[]>>;

@Component({
  name: 'bpc-pos-change-product-mandate-modal',
  components: {
    BpcInput,
    'bpc-entity-select': EntitySelect,
    'bpc-pos-contact-form': BpcPosContactForm,
  },
})
export default class PosChangeProductMandateModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({ type: Number }) readonly ticketId: number;
  @Prop({ type: Number }) readonly mandateId: number;
  @Prop({ type: Number, required: true }) readonly posSessionId!: number;
  @Prop({ type: Number }) readonly defaultContactId: number;
  @Prop({ type: Object }) readonly product: POSProduct;
  @Prop({ type: String }) readonly productType: POSProductType;
  // DATA
  saving: boolean = false;
  contact: Contact = null;
  contactId: number = null;
  ibanNumber: string = '';
  bicNumber: string = '';
  printSepa: boolean = false;

  errorsObject: errorObject = {};

  // COMPUTED
  get contactFullname() {
    return this.contact?.fullname;
  }

  // METHODS
  async getMandate() {
    if (this.mandateId) {
      const path = `${this.$bpcApiRouteHelper.getEntityPath('mandates')}/${this.mandateId}`;
      const queryConfig = {};
      const response = await this.$bpcApi.get(path, queryConfig).toPromise();
      const mandate = response?.data;
      if (mandate) {
        this.contact = mandate.contact;
        this.contactId = mandate.contact_id;
        this.ibanNumber = mandate.iban_number;
        this.bicNumber = mandate.bic_number;
      }
    }
  }

  onChangeErrorObject(field) {
    delete this.errorsObject[field];
  }

  manageSaveErrors(errors: any) {
    this.errorsObject = {};
    Object.keys(errors).forEach(key => {
      const aux = {
        error: errors[key][0],
        state: false,
      };
      this.$set(this.errorsObject, key, aux);
    });
  }

  closeModal() {
    this.$emit('on-close');
    this.resetData();
  }

  resetData() {
    this.ibanNumber = '';
    this.bicNumber = '';
    this.contact = null;
    this.contactId = null;
    this.printSepa = false;
  }

  async onConfirm() {
    this.saving = true;
    try {
      const newTicketDetail = await this.$posService.changeSubscriptionMandateData(
        this.posSessionId,
        this.ticketId,
        this.product.id,
        this.mandateId,
        this.contactId,
        this.ibanNumber,
        this.bicNumber,
      );
      this.$emit('mandate-updated', newTicketDetail);

      if (this.printSepa) {
        const templateId = this.$store.getters['centerSettings/centerSettings']?.sepa_template_id;
        await this.$printTemplateService.printTemplate('mandate', this.mandateId, templateId);
      }
      this.closeModal();
      this.saving = false;
    } catch (error) {
      if (error?.response?.data?.errors) {
        this.manageSaveErrors(error?.response?.data?.errors);
      }
      this.saving = false;
    }
  }

  // LIFECYCLE HOOKS
  mounted() {
    this.getMandate();
  }

  // WATCHERS
}
